import type { Lang } from '@seenaly/shared';
import { la } from './la';
import { en } from './en';
import type { Dict } from './types';

export type { Dict } from './types';

export const dictionaries: Record<Lang, Dict> = { la, en };

export function dictFor(lang: Lang): Dict {
  return dictionaries[lang];
}

/** Locale tag used with Intl for dates and number grouping. */
export const localeFor: Record<Lang, string> = { la: 'lo-LA', en: 'en-US' };
